import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
// @material-ui/core components
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
// other
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/components.js";

const useStyles = makeStyles(styles);

export default function HomePage() {
  const classes = useStyles();

  return (
    <div>
      <Header
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
      />
      <Parallax image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Lost and Found</h1>
                <h3 className={classes.subtitle}>Your stuff misses you too.</h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={"jumbotron text-center"}>
          <br />
          <h2>Did You Lose Something?</h2>
          <Link to="/founditems">
            <Button color="info" round>
              Check Found Items
            </Button>
          </Link>
          &nbsp;&nbsp;or&nbsp;&nbsp;
          <Link to="#reportLost">
            <Button color="info" round>
              Report Lost Item
            </Button>
          </Link>
          <h2>Did You Find Someone&apos;s Object?</h2>
          <Link to="#reportFound">
            <Button color="info" round>
              Report Found Item
            </Button>
          </Link>
          <h2>Is Your Object Given Away to Someone Else?</h2>
          <Link to="/lostitemhistory">
            <Button color="info" round>
              Check Lost Item History
            </Button>
          </Link>
          &nbsp;&nbsp;or&nbsp;&nbsp;
          <Link to="/founditemhistory">
            <Button color="info" round>
              Check Found Item History
            </Button>
          </Link>
          <br />
          <br />
        </div>
      </div>

      <Footer />
    </div>
  );
}
